import { motion, AnimatePresence } from "framer-motion";
import { Lock, Crown, Play, Check } from "lucide-react";
import { Button } from "./ui/button";

const TIER_COPY = {
  standard: { name: "Standard", price: "$15.49/mo", perks: ["1080p Full HD", "All learning games", "Offline downloads"] },
  premium: { name: "Premium", price: "$22.99/mo", perks: ["4K Ultra HD", "Early access shows", "Watch on 4 devices"] },
};

export default function UpgradeSheet({ video, isKid, onClose, onUpgrade }) {
  const tier = video?.tier === "premium" ? "premium" : "standard";
  const copy = TIER_COPY[tier];
  return (
    <AnimatePresence>
      {video && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[110] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4"
          onClick={onClose} data-testid="upgrade-sheet">
          <motion.div initial={{ y: 60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 60, opacity: 0 }}
            transition={{ type: "spring", damping: 22 }}
            className="relative w-full max-w-md bg-white rounded-t-3xl sm:rounded-3xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}>
            <div className="relative h-44">
              <img src={video.thumbnail} alt={video.title} className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/20 flex flex-col items-center justify-center text-white">
                <Lock className="h-8 w-8" />
                <span className="mt-2 rounded-full bg-[#FFC02D] text-slate-900 px-3 py-1 text-xs font-bold uppercase tracking-wide">{copy.name} show</span>
              </div>
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-display font-bold text-slate-900 flex items-center gap-2">
                <Play className="h-5 w-5 text-[#FF5A79]" /> {video.title}
              </h3>
              <p className="text-slate-500 mt-1 text-sm">{video.description}</p>

              <div className="mt-4 rounded-2xl bg-gradient-to-br from-[#FF5A79]/10 to-[#9B5DE5]/10 p-4">
                <div className="flex items-center gap-2 font-display font-bold text-slate-900">
                  <Crown className="h-5 w-5 text-[#9B5DE5]" /> Unlock with Bubz + {copy.name}
                  <span className="ml-auto text-[#FF5A79]">{copy.price}</span>
                </div>
                <ul className="mt-3 space-y-1.5">
                  {copy.perks.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-slate-600"><Check className="h-4 w-4 text-[#2EC4B6]" /> {p}</li>
                  ))}
                </ul>
              </div>

              {isKid ? (
                <div className="mt-5 text-center rounded-2xl bg-slate-50 py-4 px-3 text-slate-500 text-sm" data-testid="upgrade-kid-note">
                  🔒 Ask a grown-up to unlock this show in the Parent Zone.
                </div>
              ) : (
                <Button data-testid="upgrade-cta-btn" onClick={onUpgrade}
                  className="mt-5 w-full h-12 rounded-xl font-bold text-white bg-gradient-to-r from-[#FF5A79] to-[#9B5DE5]">
                  Unlock with {copy.name}
                </Button>
              )}
              <button onClick={onClose} className="mt-3 w-full text-sm text-slate-400 hover:text-slate-600" data-testid="upgrade-close-btn">Maybe later</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
